import React from 'react';
import { Typography, Card, Button, Space } from 'antd';
import { BarChartOutlined, DownloadOutlined, DeleteOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const SystemLogs = () => {
  return (
    <div className="admin-module">
      <div className="admin-module-header">
        <Title level={3} className="admin-module-title">System Logs</Title>
        <Text className="admin-module-description">
          View and manage system logs, including error logs and operation logs
        </Text>
      </div>

      <Card>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <BarChartOutlined style={{ fontSize: '48px', color: '#faad14', marginBottom: '16px' }} />
          <Title level={4}>System Logs</Title>
          <Text type="secondary">This feature is under development, stay tuned...</Text>
          <br /><br />
          <Space>
            <Button type="primary" icon={<DownloadOutlined />}>Export Logs</Button>
            <Button icon={<DeleteOutlined />}>Clear Logs</Button>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default SystemLogs; 